import React from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import CustomImage from "../CustomImage";
import Button from 'react-bootstrap/Button';
import router from 'next/router';
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
import Head from "next/head";

interface Props {
  eventData: any;
}

const BannerSection: React.FC<Props> = ({ eventData }) => {
  const { zipmeLink, generateLink } = useZipmeLink();
  return (
    <>
      <Head>
      <link
          rel="preload"
          as="image"
          href={eventData?.mainImageUrl}
          fetchPriority="high"
        />
      </Head>
      <div className={styles.banner} style={{ backgroundColor: eventData?.bannerBottomBgColor || '#fff' }}>
        <Container>
          <div className={styles.nav}>
            <Row>
              <Col>
                <Nav>
                  <CustomImage src={eventData?.logoUrl || "/images/educationfair/kc_logo.svg"} width={eventData?.logoUrl ? 250 : 180} height={eventData?.logoUrl ? 80 : 45} className={styles.navLogo} alt="kclogo" />
                </Nav>
              </Col>
            </Row>
          </div>
          <div className={styles.maincontent}>
            <Row>
              <Col xl={6} lg={6} md={12} xs={12}>
                <div className={`${styles.mainSectionBg} ${styles.fairdetails}`}>
                    <div className={styles.heading}>
                      <h1 style={{ color: eventData?.titleTextColor || "#fff" }}>{eventData?.attendTitleText}</h1>
                      <h2 style={{ color: eventData?.titleTextColor || "#fff" }}>{eventData?.eventName}</h2>
                      <p style={{ color: eventData?.subTitleTextColor || "#FDA64F" }}>{eventData?.subTitle}</p>
                    </div>
                  <div className={styles.sponserdSecdesk}>
                    <span>{eventData?.copoweredSection?.sectionTitle}</span>
                    {
                      eventData?.copoweredSection?.sectionImages?.length > 0 &&
                      eventData?.copoweredSection?.sectionImages.map((images: any) => <CustomImage src={images?.imageUrl} width={110} height={40} alt="co-powered image" />)
                    }
                  </div>
                  <div className={styles.fairdetails}>
                    <div className={styles.events}>
                      {eventData?.dateAndTime && <div className={styles.time}>
                        <div className={styles.icon}><CustomImage src="/images/educationfair/addre.png" width={30} height={30} className={styles.studImg} alt="addre.png" /></div>
                        <div><p style={{ color: eventData?.dateTimeTextColor || "#fff" }}>{eventData?.dateAndTime}</p></div>
                      </div>}
                      {eventData?.location && <div className={styles.location}>
                        <div className={styles.icon}><CustomImage src="/images/educationfair/location.png" width={30} height={30} className={styles.studImg} alt="location.png" /></div>
                        <div><p style={{ color: eventData?.locationTextColor || "#fff" }}>{eventData?.location}</p></div>
                      </div>}
                    </div>
                    <div className={styles.regBtn}>
                      <Button id='enquirebt'
                      variant='primary'
                      size='lg' onClick={() => {
                      !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                      }}
                      className={`${eventData?.meta?.jotforms[0]?.jotformid
                          ? `btn ${isFrappeOrJotFormClass(eventData?.meta?.jotforms[0]?.jotformid)}`
                          : ''
                          } ${styles.btnReg}`}
                  >
                      Register Now
                </Button>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xl={6} lg={6} md={12} xs={12}>
                <div className={styles.bannerStudDiv}>
                  <div className={styles.bg}>
                    <CustomImage src={eventData?.mainImageUrl} width={640} height={427} className={styles.studImg} alt="location.png" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

export default BannerSection;
